/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Chip_10kInputs */

const tr_landing_genius_chip_10k = /** @type {(inputs: Landing_Genius_Chip_10kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10K kredi`)
};

const en_landing_genius_chip_10k = /** @type {(inputs: Landing_Genius_Chip_10kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10K credits`)
};

const de_landing_genius_chip_10k = /** @type {(inputs: Landing_Genius_Chip_10kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10K Credits`)
};

const ru_landing_genius_chip_10k = /** @type {(inputs: Landing_Genius_Chip_10kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10K кредитов`)
};

/**
* | output |
* | --- |
* | "10K credits" |
*
* @param {Landing_Genius_Chip_10kInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_chip_10k = /** @type {((inputs?: Landing_Genius_Chip_10kInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Chip_10kInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_chip_10k(inputs)
	if (locale === "de") return de_landing_genius_chip_10k(inputs)
	if (locale === "ru") return ru_landing_genius_chip_10k(inputs)
	return tr_landing_genius_chip_10k(inputs)
});